import { css } from '@emotion/react';
import { useState } from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import type { ModalProps } from '~/modal/modalType.enum';
import { NpsDetailsComponent } from './npsDetails.component';

const wrapperStyle = css({
  padding: 18,
});

export type NpsDetailsModalProps = ModalProps<{
  score: number;
  onDismiss?: () => void;
  onSave: (description: string) => void;
}>;

export const NpsDetailsModalContainer = ({
  onClose,
  onDismiss,
  onSave,
  score,
  ...props
}: NpsDetailsModalProps) => {
  const [t] = useTranslation();
  const [optionalDetails, setOptionalDetails] = useState('');

  const handleDone = () => {
    onSave(optionalDetails);
    onClose();
  };

  const handleClose = () => {
    onDismiss?.();
    onClose();
  };

  return (
    <ModalComponent
      caption={t('nps.title')}
      confirmButton={(
        <ButtonComponent
          onClick={handleDone}
          text={t('Done')}
        />
      )}
      contentStyle={wrapperStyle}
      isOpen={props.isOpen}
      onClose={handleClose}
    >
      <NpsDetailsComponent
        details={optionalDetails}
        onDetailsChange={setOptionalDetails}
        score={score}
      />
    </ModalComponent>
  );
};
